/* eslint-disable @typescript-eslint/no-explicit-any */

Array.prototype.sortByProperty = function <T>(
  this: T[],
  property: keyof T,
  DESC = true,
): T[] {
  return this.sort((a, b) => {
    if (a[property] > b[property]) return DESC ? 1 : -1;
    if (a[property] < b[property]) return DESC ? -1 : 1;
    return 0;
  });
};

Array.prototype.flatten = function <T>(this: T[][]): T[] {
  return ([] as T[]).concat(...this);
};

Array.prototype.toObject = function <T extends Record<string, any>>(
  this: T[],
): Record<string, unknown> {
  return this.reduce((obj: Record<string, unknown>, item) => {
    const [key] = Object.keys(item);
    obj[key] = item[key];
    return obj;
  }, {});
};

Array.prototype.toObjectWithKey = function <T>(
  this: T[],
  key: keyof T,
): Record<string, T> {
  return this.map((item) => ({
    [item[key] as string]: item,
  })).toObject() as Record<string, T>;
};

Array.prototype.findBy = function <T>(
  this: T[],
  object: Partial<T>,
): T | undefined {
  const [key] = Object.keys(object) as (keyof T)[];
  return this.find((item) => item[key] === object[key]);
};

Array.prototype.uniqBy = function <T>(this: T[], property: keyof T): T[] {
  return this.filter(
    (item, index, arr) =>
      arr.findIndex((nested) => nested[property] === item[property]) === index,
  );
};

Array.prototype.uniq = function <T>(this: T[]): T[] {
  return this.filter((item, index, arr) => arr.indexOf(item) === index);
};

Array.prototype.mutateObjectBy = function <T>(
  this: T[],
  property: keyof T,
  mutator: Partial<T>,
): T[] {
  return this.map((item) => {
    if (item[property] === mutator[property]) return { ...item, ...mutator };
    return item;
  });
};

Array.prototype.only = function <T, K extends keyof T>(
  this: T[],
  property: K,
): T[K][] {
  return this.map((item) => item[property]).filter((item) => item);
};

Array.prototype.max = function <T>(this: T[], count: number): T[] {
  return this.filter((_item, index) => index < count);
};

Array.prototype.rotate = function <T>(this: T[], count: number): T[] {
  const len = this.length >>> 0;
  let normalizedCount = count >> 0;

  normalizedCount = ((normalizedCount % len) + len) % len;

  const removed = this.splice(0, normalizedCount);
  this.push(...removed);
  return this;
};

Array.prototype.equals = function <T>(this: T[], array: T[]): boolean {
  if (!array) return false;
  if (this.length !== array.length) return false;

  for (let i = 0; i < this.length; i++) {
    if (this[i] instanceof Array && array[i] instanceof Array) {
      if (!(this[i] as unknown as T[]).equals(array[i] as unknown as T[])) {
        return false;
      }
    } else if (this[i] !== array[i]) {
      return false;
    }
  }
  return true;
};

Number.prototype.toFixedNumber = function (
  this: number,
  digits: number,
  base = 10,
): number {
  const pow = Math.pow(base, digits);
  return Math.round(this * pow) / pow;
};

String.prototype.capitalize = function (this: string): string {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

// Hide method from for-in loops
Object.defineProperty(Array.prototype, 'equals', { enumerable: false });

export {};
